import { API } from "@/lib/api";

let es = null;
const listeners = new Set();

export function initLive() {
  if (es) return;
  try {
    es = new EventSource(`${API}/stream/events`, { withCredentials: true });
    es.onmessage = (e) => {
      try { const d = JSON.parse(e.data); listeners.forEach((l) => l(d)); } catch {}
    };
    es.onerror = () => { /* browser auto-reconnects */ };
  } catch {}
}

export function onLive(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}
